(() => {
  const refresh = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && !document.getElementById('main-cart-items')) {
      const res = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
      const sections = await res.json();
      drawer.renderContents({ sections });
    } else {
      window.location.reload();
    }
  };
  const post = (url, body) =>
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then((r) => { if (!r.ok) throw new Error('cart'); return r.json(); });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-hm-cart-action]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    try {
      const root = window.Shopify.routes.root;
      if (btn.dataset.hmCartAction === 'add') {
        await post(`${root}cart/add.js`, { items: [{ id: Number(btn.dataset.id), quantity: 1 }] });
      } else if (btn.dataset.hmCartAction === 'swap') {
        const properties = {};
        Object.keys(btn.dataset).filter((k) => k.startsWith('prop')).forEach((k) => {
          const [name, ...rest] = btn.dataset[k].split('|');
          properties[name] = rest.join('|');
        });
        await post(`${root}cart/change.js`, { id: btn.dataset.key, quantity: 0 });
        await post(`${root}cart/add.js`, { items: [{ id: Number(btn.dataset.target), quantity: Number(btn.dataset.qty) || 1, properties }] });
      }
      await refresh();
    } catch (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      console.error(err);
    }
  });
})();
